module.exports = __webpack_public_path__ + "img/la_base_la_nuit_450px_haut.48f9a02e.jpg";